import gql from "graphql-tag";

export const stripeCustomerPortal = gql`
  query stripeCustomerPortal($input: GetStripeCustomerPortalInput!) {
    stripeCustomerPortal(input: $input) {
      customerPortalUrl
    }
  }
`;

export const stripeCustomerPortalOptions = {
  name: "stripeCustomerPortal",
};
